/**
 * 数据传输安全改造：HMAC-SHA256 签名生成
 * 与后端 org.jeecg.config.crypto.SignatureInterceptor 对应：
 * 签名串 = method=xx&path=xx&timestamp=xx&nonce=xx&body=xx&signToken=xx
 * 签名算法 = HMAC-SHA256(签名串, signToken)，输出十六进制小写
 */
import CryptoJS from 'crypto-js';

/**
 * 生成 HMAC-SHA256 签名
 * @param {Object} params
 * @param {string} params.method HTTP 方法（大写）
 * @param {string} params.path 请求相对路径（去掉 baseURL/查询串）
 * @param {string} params.timestamp 时间戳
 * @param {string} params.nonce 随机串
 * @param {string} params.body 请求体明文 JSON 串（GET 为空串）
 * @param {string} params.signToken 协商得到的签名 token
 * @returns {string} 十六进制小写签名
 */
export function generateSign({ method, path, timestamp, nonce, body, signToken }) {
  const signString = [
    `method=${method}`,
    `path=${path}`,
    `timestamp=${timestamp}`,
    `nonce=${nonce}`,
    `body=${body || ''}`,
    `signToken=${signToken}`,
  ].join('&');

  return CryptoJS.HmacSHA256(signString, signToken).toString(CryptoJS.enc.Hex);
}

/**
 * 生成 UUID v4（防重放 nonce），避免引入额外 uuid 依赖
 * @returns {string} UUID v4
 */
export function uuidV4() {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
